exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-marketing-redirect-js": () => import("./../../../src/pages/marketing-redirect.js" /* webpackChunkName: "component---src-pages-marketing-redirect-js" */),
  "component---src-pages-ping-ts": () => import("./../../../src/pages/ping.ts" /* webpackChunkName: "component---src-pages-ping-ts" */),
  "component---src-templates-drivescore-landing-tsx": () => import("./../../../src/templates/drivescore-landing.tsx" /* webpackChunkName: "component---src-templates-drivescore-landing-tsx" */)
}

